__turbopack_context__.v({
  "container": "features-module__syPsrG__container",
});
